import {
  Box,
  Stack,
  Typography,
  styled
} from '@mui/material';
import { CalculationSentiment } from 'generated/graphql';
import _ from 'lodash';


const SentimentBox = styled(Box, {
  shouldForwardProp: (p) => (
    p !== 'isSelected'
    && p !== 'sentiment'
  )
})<{
  sentiment: CalculationSentiment;
  isSelected: boolean;
}>(({ sentiment, isSelected }) => ({
  borderRadius: 1,
  width: 13.5,
  height: 12,
  border: `1px solid ${isSelected ? __getStrokeColor(sentiment) : __getBackgroundColor(sentiment)}`,
  backgroundColor: __getMainColor(sentiment),
  borderColor: isSelected ? __getStrokeColor(sentiment) : __getBackgroundColor(sentiment),
  opacity: isSelected ? 1 : 0.3,
  '@media print': {
    display: 'none'
  },
  ':first-of-type': {
    borderTopLeftRadius: '4px',
    borderBottomLeftRadius: '4px'
  },
  ':last-of-type': {
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '4px'
  }
}));



function __getMainColor(sentiment: CalculationSentiment): string {
  switch (sentiment) {
    case 'bad':
      return '#EF4563';
    case 'good':
      return '#02C37E';
    case 'neutral':
      return '#F2AE00';
    case 'nmf':
      return '#B5BDB9';
  }
}



function __getStrokeColor(sentiment: CalculationSentiment) {
  switch (sentiment) {
    case 'bad':
      return '#BA123A';
    case 'good':
      return '#0B9865';
    case 'neutral':
      return '#DD8500';
    case 'nmf':
      return '#67726D';
  }
}


function __getBackgroundColor(sentiment: CalculationSentiment): string {
  switch (sentiment) {
    case 'bad':
      return '#FEF4F4';
    case 'good':
      return '#F2FCF8';
    case 'neutral':
      return '#FFF9E6';
    case 'nmf':
      return '#FAFAFA';
  }
}


export type CalculationRatingWidgetProps = {
  sentiment: CalculationSentiment;
};

export const FC = ({
  sentiment
}: CalculationRatingWidgetProps) => {
  const sentiments: CalculationSentiment[] = [
    'good',
    'neutral',
    'bad',
    'nmf'
  ];
  return (
    <Stack
      direction='row'
      sx={{
        alignItems: 'center',
        gap: '4px',
        padding: '4px',
        borderRadius: '4px',
        backgroundColor: __getBackgroundColor(sentiment),
        marginRight: 'auto'
      }}
    >
      <Stack
        direction='row'
        gap='2px'
      >
        {sentiments.map((s) => (
          <SentimentBox
            sx={{
            }}
            key={s}
            sentiment={s}
            isSelected={s === sentiment}
          />
        ))}
      </Stack>

      <Typography
        sx={{
          fontFamily: 'lexend',
          lineHeight: '16px',
          size: '11px',
          textTransform: 'uppercase',
          color: __getStrokeColor(sentiment)
        }}
      >
        {_.startCase(sentiment)}
      </Typography>
    </Stack>
  );
};
